// extracted by mini-css-extract-plugin
export default {"modalBody":"style_modalBody__54D3s"};